// 1. First, let's fix the routes.tsx file
// File: drive-course-app\src\routes.tsx
import { RouteProps } from 'react-router-dom';

// Import all pages
import Home from './pages/Home';
import Recent from './pages/Recent';
import Favorites from './pages/Favorites';
import LogIn from './pages/LogIn';
import Logout from './pages/Logout';
import Faq from './pages/Faq';
import About from './pages/About';
import DrivesPage from './pages/DrivesPage';
import FileandfolderPage from './pages/FileandFolderPage';
import DrivesManager from './pages/DrivesManager';
import QuestionButton from './pages/Communication';

type AppRoute = RouteProps & {
  component: React.ComponentType<any>; // The page component
  // You can add additional route-specific props here
}

export const routes: RouteProps[] = [
  
  { path: '/', exact: true, component: Home },
  {path:'/Communication',component:QuestionButton},
  { path: '/drives', component: DrivesPage },
  { path: '/recent', component: Recent },
  { path: '/favorites', component: Favorites },
  { path: '/login', component: LogIn },
  { path: '/logout', component: Logout },
  { path: '/faq', component: Faq },
  { path: '/about', component: About },
  {path:'/drivemanager',component: DrivesManager},
  // Fix this route to match with DriveCard navigation
  { path: '/drive/:driveName', component: FileandfolderPage },
  // Remove this redundant route as we're using query params for folders
  // { path: '/files/:driveName/:folderId?', component: FileandfolderPage, exact: false }
];